(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bilngwe-home"] && !Shopify.designMode) return;
  try {
    
function setupHeroVideo(){
 const video=document.querySelector('.bb-hero-video');
 if(!video||video.dataset.ready)return;
 video.dataset.ready='true';
 video.muted=true;
 video.controls=false;
 const update=()=>video.classList.toggle('is-playing',!video.paused&&video.readyState>=2);
 ['playing','pause','error','stalled','emptied'].forEach(event=>video.addEventListener(event,update));
 update();
 if(!matchMedia('(max-width:800px), (prefers-reduced-motion:reduce)').matches){
  const attempt=video.play();
  if(attempt&&typeof attempt.catch==='function')attempt.catch(update);
 }
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',setupHeroVideo);}else{setupHeroVideo();}
document.addEventListener('shopify:section:load',setupHeroVideo);
function setupHomeServiceCarousel(){
 const track=document.getElementById('bb-home-services-carousel');
 if(!track||track.dataset.arrowsReady)return;
 track.dataset.arrowsReady='true';
 const buttons=track.parentElement.querySelectorAll('[data-bb-slide]');
 const update=()=>{const photo=track.querySelector('.bb-photo');if(photo)track.parentElement.style.setProperty('--bb-arrow-top',photo.getBoundingClientRect().height/2+'px');buttons.forEach(button=>{button.disabled=Number(button.dataset.bbSlide)<0?track.scrollLeft<=2:track.scrollLeft>=track.scrollWidth-track.clientWidth-2;});};
 buttons.forEach(button=>button.addEventListener('click',()=>{
  const card=track.querySelector('article');
  const distance=card?card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap||0):track.clientWidth;
  track.scrollBy({left:Number(button.dataset.bbSlide)*distance,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
 }));
 track.addEventListener('scroll',update,{passive:true});
 new ResizeObserver(update).observe(track);
 update();
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',setupHomeServiceCarousel);}else{setupHomeServiceCarousel();}
document.addEventListener('shopify:section:load',setupHomeServiceCarousel);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bilngwe-services"] && !Shopify.designMode) return;
  try {
    
function initializeBilngweServices(){document.querySelectorAll('[data-bb-services]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';root.querySelectorAll('[data-bb-filter]').forEach(button=>button.addEventListener('click',()=>{const filter=button.dataset.bbFilter;root.querySelectorAll('[data-bb-filter]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));root.querySelectorAll('[data-bb-category]').forEach(card=>{card.hidden=filter!=='all'&&card.dataset.bbCategory!==filter;});}));});}initializeBilngweServices();document.addEventListener('shopify:section:load',initializeBilngweServices);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
